const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyFlexibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 131.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45.3,
    cy: 61.7,
    r: 14.8,
    style: {
      fill: "#48a83e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1,69.4H38.4A.4.4,0,0,1,38,69V55.7c0-.2.1-.4.3-.4l8.8-1.2c.1-.1.2,0,.3,0a.4.4,0,0,1,.1.3V69A.4.4,0,0,1,47.1,69.4Zm-8.3-.8h7.9V54.9l-7.9,1.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5,69.4H42a.4.4,0,0,1-.4-.4V65.9a.4.4,0,0,1,.4-.4h1.5a.4.4,0,0,1,.4.4V69A.4.4,0,0,1,43.5,69.4Zm-1.1-.8h.7V66.3h-.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 62.3,
    width: 1.5,
    height: 1.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 58.7,
    width: 1.5,
    height: 1.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3,69.4H47.1a.4.4,0,0,1-.4-.4V59.5c0-.1.1-.2.2-.3s.2-.1.3,0l5.2,1c.1.1.3.2.3.4V69A.4.4,0,0,1,52.3,69.4Zm-4.8-.8h4.4V60.9L47.5,60Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7,69.4a.4.4,0,0,1-.4-.4V67a.4.4,0,1,1,.8,0v2A.4.4,0,0,1,49.7,69.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.5,49.4a18.7,18.7,0,0,1,0,6.7,64.3,64.3,0,0,1-1.9,8.6,80.4,80.4,0,0,1-3.2,9.4c-1.2,3.2-2.5,6.2-3.8,9.1s-2.6,5.6-3.8,8.1-2.2,4.4-3.1,5.9-2.8,4.4-4.7,7.1a92,92,0,0,1-5.9,7.7,77.2,77.2,0,0,1-5.7,6.4c-1.9,1.8-3.3,2.8-4.4,3.1a6.2,6.2,0,0,1-4.5-.9l-2.2-1.5c-.8-.7-1.7-1.3-2.5-2.1a16,16,0,0,1-2.3-2.1,6.3,6.3,0,0,1-1.3-2.1,2.2,2.2,0,0,1,.2-1.4,5.7,5.7,0,0,1,1.1-1.2l1.6-1.5c.9-.7,1.9-1.7,3-2.7l3.7-3.5,3.4-3.6a26.9,26.9,0,0,0,2.4-3.3,3.9,3.9,0,0,0,.8-2.4c-.1-.4-.6-.8-1.4-1.1l-2.6-1-2.6-1.4a4.5,4.5,0,0,1-1.6-2.4c-.2-1-.4-2.6-.7-4.8s-.4-4.5-.6-7.2-.4-5.6-.6-8.5-.2-5.7-.2-8.4.1-5,.2-7a16.5,16.5,0,0,1,.8-4.4,4,4,0,0,1,2.9-2.1,9.5,9.5,0,0,1,2.9.3l5.1,1.2a46.5,46.5,0,0,1,4.9,1.7q2.3,1,2.4,2.1a16.1,16.1,0,0,1,.2,4.7c-.1,2.2-.3,4.5-.5,7l-.6,7.6a52.9,52.9,0,0,0-.2,6.7c.1,1.4.3,2.2.7,2.2s.9-.5,1.4-1.9a119.7,119.7,0,0,0,5.2-17.4A103.1,103.1,0,0,0,293.9,44a7.7,7.7,0,0,1,.3-2,1.5,1.5,0,0,1,1.3-.9,13.1,13.1,0,0,1,9,1.6,14.7,14.7,0,0,1,3.2,2.9A9.5,9.5,0,0,1,309.5,49.4Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.7,101l-.2-.3c-6.9-11.6-8.2-22.5-9.6-36.8a31,31,0,0,1-.2-4.3,16.2,16.2,0,0,0-1.9,3.5c-1.9,4.7-3.6,9.6-5.2,14.5-.7,2.4-1.5,4.8-2.2,7.2s-1.7,7-5.2,8.6a18.3,18.3,0,0,1-7.7,1.2c-1.5,0-2.9.1-4.4,0s-3-.1-3.8-.9-1.1-3-1.2-4.2l-.3-8.2c-.1-2.9-.2-6-.3-9s0-8.1.1-12.2.2-7.3.3-9.7c-.2.4-.9,2-2.1,4.9l-4,10.7-5.2,13.4c-1,2.5-2,5-3.1,7.5s-1.7,5.6-5,7.1a24.7,24.7,0,0,1-5.2,1.8c-2.3.5-6.1,1.8-7.7-.6a5.1,5.1,0,0,1-.9-2.7c0-16,2.8-29.2-2.4-49.3l-1.1.3c-.2,0-1.4-5.9-.6-6.3s10.2-7.5,11.3-8.1a7.5,7.5,0,0,1,2.9-.8c1.1,0,1.7.7,2.2,2.2a41.1,41.1,0,0,1,1.6,6.3c.4,2.5,1,8.7,1.5,13.6,2.5-4.3,4.4-7.6,5.9-10s2.6-4.4,3.5-5.7a23.9,23.9,0,0,1,4.9-6.1c2.2-1.9,4.8-2.7,7.6-3.5s4.2-1.2,6.5-1.7a29.7,29.7,0,0,1,4.1-.8c1.9-.2,3.1-.4,3.4,1.8,1.4,10.3,1.2,20.9,1.2,31.3.2-.6,1.4-3.4,1.8-4.2,2.3-4.7,4.3-9.1,6.6-13.6a48.3,48.3,0,0,1,3.3-6.4c2.4-4.2,8.1-5.6,12.5-6.3,1.6-.3,5.6-1.1,6.9.3s.2,1.8.2,2.5a33.8,33.8,0,0,1,0,4.5c0,3.3-.1,7.2-.2,11.6s-.1,9.1-.2,14.2,0,9.9.1,14.7.4,9.3.7,13.4c.2,1.8.4,3.7.7,5.5s.3,1.6.4,2.4.7,1.5.5,2-2.9,1.9-3.8,2.4a30.4,30.4,0,0,1-6.6,2.3Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.3,26.2h36.4v9.9H341.4V56.4h24.9v9.8H341.4V96.1H330.3Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.8,26.2h9.8V96.1h-9.8Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.1,73.5c.4,10.4,9.5,15.7,17.2,15.7a16.1,16.1,0,0,0,14.9-8.7h10.1A28.4,28.4,0,0,1,428,93.3a26.6,26.6,0,0,1-14.7,4.3c-16.8,0-27.1-13.5-27.1-27.1a27.2,27.2,0,0,1,46-19.7c6.1,6.1,8.6,14.1,7.8,22.7Zm34.1-7.6c-.4-6.8-7.2-14.5-17-14.3s-16.5,7.3-16.9,14.3Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.3,69.4,438.1,44.7H450l11.4,17.7,11.3-17.7h11.7L467.2,69.4l18.6,26.7h-12L461.4,77,448.8,96.1h-12Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.1,26.2h9.8V36.6h-9.8Zm0,18.5h9.8V96.1h-9.8Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506,26.2h9.8V53a23.7,23.7,0,0,1,18.9-9.8c13.3,0,26.1,9.9,26.1,27s-11.7,27.4-26.5,27.4c-8.7,0-15.5-4.3-18.8-10.4v8.9H506Zm44.9,44.1a17.5,17.5,0,0,0-17.7-17.9c-10.6,0-17.7,8.2-17.7,17.9s6.9,18.1,17.4,18.1,17.9-9.1,18-18Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.8,26.2h9.9V36.6h-9.9Zm0,18.5h9.9V96.1h-9.9Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.8,26.2h9.8V96.1h-9.8Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.7,26.2h9.8V36.6h-9.8Zm0,18.5h9.8V96.1h-9.8Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.3,52.4h-9.2V44.7h9.2V26.2h9.8V44.7H643v7.7h-9.9V96.1h-9.8Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.4,94.6,639.7,44.7h10.6l14.2,37.6,14.3-37.6h10.6l-28,70.1H650.9Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.5,
    cy: 61.7,
    rx: 25.4,
    ry: 25.6,
    style: {
      fill: "#48a83e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,74.6h2.8a7.3,7.3,0,0,0,4.3-1.4H84.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,57.1a.8.8,0,0,0-1.1-.2l-1.5,1-2.1-1a3.5,3.5,0,0,0-1.2-.3,2.2,2.2,0,0,0-2.1,2.1V66a2.5,2.5,0,0,0,2.5,2.5h3.7a1.9,1.9,0,0,0,2-1.8V63.6c0-.3,0-.7.5-.8h.9a.5.5,0,0,0,.3-.7,28,28,0,0,0-1.9-4.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8,56.5a4.4,4.4,0,0,0-4.4-4.5,6.9,6.9,0,0,0-4,1h-.2a4.9,4.9,0,0,0-2.4-1.4c-.1,0-.1-.3,0-.3a17.6,17.6,0,0,1,5,.2c.2,0,.3-.1.2-.3s-.1-.2-.2-.4a1.9,1.9,0,0,0-1.3-1,29.9,29.9,0,0,0-7.3-1,33.7,33.7,0,0,0-6.9.8h-.5c-.2,0-.2.3-.2.4a.5.5,0,0,1,.3.3c.1.1.2.3,0,.4l-5.5,5h3.8a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5H79.4l-1.5,1.3h6.4c.2,0,.4.3.4.5a.5.5,0,0,1-.4.5H76.8l-1.5,1.4H88.2a.5.5,0,0,1,.4.5c0,.2-.2.5-.4.5H75.3v1.3H88.2c.2,0,.4.3.4.5a.5.5,0,0,1-.5.5H75.3v1.4H92.1a.5.5,0,0,1,.4.5c0,.2-.2.5-.4.5H79.8v1.3H92.1c.2,0,.4.3.4.5a.5.5,0,0,1-.4.5H79.8v1.4H94a7.6,7.6,0,0,0,.5-2.6V58.2a2.2,2.2,0,0,1,1.7-2.3h.2a18.9,18.9,0,0,1,10.9.9c.4.2.5-.1.5-.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,72.2h8.2a7.6,7.6,0,0,0,1-1.3H84.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,73.8c0-.2-.1-.2-.2-.2H83v.6h.1v-.3h.1v.3h.1v-.3c.1,0,.1,0,.1-.1m-.3,0h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2,73.3a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.5.5.5,0,0,0,.5-.5.6.6,0,0,0-.5-.6m0,1a.4.4,0,0,1-.4-.4c0-.3.1-.5.4-.5a.5.5,0,0,1,.4.5.4.4,0,0,1-.4.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,100A38.4,38.4,0,0,1,56.7,77.6L55,78.7a40.3,40.3,0,0,0,73.2-.3l-1.7-1.2A38.4,38.4,0,0,1,91.5,100Z",
    style: {
      fill: "#48a83e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,23.4a38.4,38.4,0,0,1,35,22.8l1.7-1.2a40.2,40.2,0,0,0-73.1-.3l1.7,1.1A38.2,38.2,0,0,1,91.5,23.4Z",
    style: {
      fill: "#48a83e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.4,
    cy: 61.7,
    r: 14.8,
    style: {
      fill: "#48a83e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,71.1a9.4,9.4,0,1,1,9.3-9.4A9.4,9.4,0,0,1,138.4,71.1Zm0-17.9a8.6,8.6,0,1,0,8.5,8.5A8.5,8.5,0,0,0,138.4,53.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.5,67.2h-.3c-.5-.3-.6-1.4-.6-1.9s-.1-3.4-1.6-3.9l-1.7-.6a.9.9,0,0,1-.7-.9,1.6,1.6,0,0,1,.9-1.7c.3-.1.5-.2.7-.1v-.5c-.1-.3-.1-.5-.2-.6a1.7,1.7,0,0,0-1,0h-.4c-.2,0-.2.1-.5,1.5v.3c-.1.4-.3.7-.6.7s-.9-.5-1-.6a3.5,3.5,0,0,1-.1-.6c-.1.2-.4.6-1.4,1a1,1,0,0,1-1-.2c-.5-.6,0-2,.3-2.6s.3-.3.5-.2a.4.4,0,0,1,.2.5,3.5,3.5,0,0,0-.4,1.7h.1a2.1,2.1,0,0,0,1-.6l.6-1.1a.4.4,0,0,1,.5-.2.5.5,0,0,1,.3.3,4.7,4.7,0,0,0,.2,1.6h0v-.3c.3-1.4.4-2.1,1.3-2.1h.3a2.3,2.3,0,0,1,1.6.2,1.9,1.9,0,0,1,.5,1.2c0,.6,0,.9-.2,1.1a.6.6,0,0,1-.5.2h-.5a.9.9,0,0,0-.4.9c0,.2.1.2.1.2l1.8.6c2.1.8,2.1,3.2,2.1,4.7a3.3,3.3,0,0,0,.2,1.2c.7-.6,2.4-3.4,2.1-4.2s-.6-1.7.5-2.2,1-.8,1-1.1.2-.4.4-.5a.4.4,0,0,1,.4.4c.1.7-.4,1.3-1.4,1.9s-.5.2-.2,1.2-1.7,4.7-2.4,5.2Zm-9-8.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,67.4h-.1a.5.5,0,0,1-.3-.5c.8-2.2,1.1-2.6,1.7-3.1h.1l-.6-.3-1-.5-.6-.4-.4-.3c-.1.4-.2,1.1-.3,1.7a.4.4,0,0,1-.4.4c-.2-.1-.4-.2-.4-.5.2-2.2.7-2.4.9-2.4s.3-.1.5.1l.5.3.7.5.8.4c.6.2,1.1.4,1.2.8a.8.8,0,0,1-.3.7l-.2.2c-.5.3-.7.5-1.4,2.7Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFlexibility);
export default __webpack_public_path__ + "static/media/my-flexibility.5bcf13cc888954e3fd40e31f396a5592.svg";
export { ForwardRef as ReactComponent };